// Default regex of material :
// Looks for three chunks of content (either numbers or text) separated by delimiters,
// and additional regex for 6-8 digits.
// \p{Nd} matches any Unicode decimal digit (e.g. Eastern Arabic-Indic ٠-٩ used by moment's Arabic locale),
// not just ASCII 0-9, so locales that render dates with non-Latin digits are recognized as complete.
// ‎/‏ (LRM/RLM) are zero-width bidi marks moment's Arabic locale embeds around delimiters
// (see node_modules/moment/locale/ar.js longDateFormat.L: 'D/‏M/‏YYYY') for correct RTL rendering.
const dateCompleteRegExp = new RegExp(
	'^' +
		'(' +
		'(' +
		'([a-zA-Z]{3,}|[0-9\\p{Nd}]{1,4})' +
		'([ .,\\u200e\\u200f]+|[/\\-\\u200e\\u200f]+)' +
		'){2}' +
		'([a-zA-Z]{3,}|[0-9\\p{Nd}]{1,4})' +
		')' +
		'|' +
		'([0-9\\p{Nd}]{6}|[0-9\\p{Nd}]{8})' +
		'$',
	'u'
);

export function isDateComplete(dateString: string): boolean {
	return dateCompleteRegExp.test(dateString.trim());
}
